export const userInfoSessionStoreage = {};
const SessionStoreageKey = "userInfo";
userInfoSessionStoreage.get = () => {
  try {
    return JSON.parse(sessionStorage.getItem(SessionStoreageKey) || {});
  } catch (error) {
    return {};
  }
};

userInfoSessionStoreage.set = (userInfo) => {
  if (userInfo.errcode < 0) return
  sessionStorage.setItem(SessionStoreageKey, JSON.stringify(userInfo));
};
